var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilledArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#929596"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.695 9l5.44-6.54c.53-.636.444-1.583-.191-2.112-.637-.531-1.58-.444-2.109.192l-7.488 9c-.058.07-.088.153-.131.23-.036.064-.08.118-.107.187-.067.172-.108.354-.108.537L0 10.5l.001.006c0 .183.04.364.108.537.027.069.07.123.107.186.043.078.073.16.131.23l7.488 9.001c.297.355.722.54 1.15.54.339 0 .679-.114.959-.348.635-.53.722-1.476.191-2.112L4.695 12h14.807C20.33 12 21 11.328 21 10.5S20.33 9 19.502 9H4.695z",
    transform: "translate(-20 -79) translate(20 79)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilledArrowLeft);
export default __webpack_public_path__ + "static/media/icon-filled-arrow-left.88127c13087d7677883f108428eeeb89.svg";
export { ForwardRef as ReactComponent };